<template>
  <div>
    <form class="w-100" @submit.prevent="submit">
      <div class="row">
        <div class="col-12 text-left">
          <button @click="smsDialog = true" type="button" class="btn btn-info">
            ارسال پیامک
            <i class="fas fa-paper-plane"></i>
          </button>
          <button
            v-if="id !== 'new'"
            @click="del"
            type="button"
            class="btn btn-danger mr-2"
          >
            حذف کاربر
            <i class="fas fa-trash" />
          </button>

          <button type="submit" class="btn btn-success mr-2">
            <span v-if="id !== 'new'">
              بروررسانی پروفایل
              <i class="far fa-save" />
            </span>
            <span v-else>
              افزودن کاربر
              <i class="fas fa-plus" />
            </span>
          </button>
          <hr />
        </div>
        <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
          <StatsCard>
            <div class="icon-big text-center icon-primary" slot="header">
              <i class="fas fa-unlock-alt" />
            </div>
            <div class="numbers" slot="content">
              <p>رمزعبور</p>
              {{ user.password_secured ? "دارد" : "ندارد" }}
            </div>
          </StatsCard>
        </div>
        <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
          <StatsCard>
            <div class="icon-big text-center icon-info" slot="header">
              <i class="fas fa-table" />
            </div>
            <div class="text-center" slot="content">
              <p>تاریخ ثبت نام</p>
              {{ $dateTimeFormat(user.created_at) }}
            </div>
          </StatsCard>
        </div>
        <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
          <StatsCard>
            <div class="icon-big text-center icon-warning" slot="header">
              <i class="fas fa-table" />
            </div>
            <div class="text-center" slot="content">
              <p>تاریخ پایان اشتراک</p>
              {{ $dateTimeFormat(user.premium_until) }}
            </div>
          </StatsCard>
        </div>
        <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
          <StatsCard>
            <div class="icon-big text-center icon-success" slot="header">
              <i class="far fa-gem" />
            </div>
            <div class="text-right" slot="content">
              <p><b>اشتراک فعال</b></p>
              <div v-if="user.is_premium">دارد</div>
              <div v-else>ندارد</div>
            </div>
          </StatsCard>
        </div>
        <div
          v-if="id === 'new' || (id !== 'new' && Object.keys(user).length)"
          class="col-12"
        >
          <div class="row">
            <div class="col-12 col-md-6 col-lg-7 col-xl-8 mb-4">
              <card class="card h-100" title="پروفایل کاربر">
                <div>
                  <div class="form-row">
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="name">نام</label>
                        <input
                          id="name"
                          type="text"
                          class="form-control"
                          placeholder="نام"
                          v-model="user.name"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="family_name">نام خانوادگی</label>
                        <input
                          id="family_name"
                          type="text"
                          class="form-control"
                          placeholder="نام خانوادگی"
                          v-model="user.family_name"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="username">نام کاربری</label>
                        <input
                          id="username"
                          type="text"
                          class="form-control"
                          placeholder="نام کاربری"
                          v-model="user.username"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="mobile">شماره موبایل</label>
                        <input
                          dir="ltr"
                          id="mobile"
                          type="text"
                          class="form-control text-right"
                          placeholder="شماره موبایل"
                          v-model="user.mobile"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="email">ایمیل</label>
                        <input
                          dir="ltr"
                          id="email"
                          type="text"
                          class="form-control text-right"
                          placeholder="ایمیل"
                          v-model="user.email"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="country">پیش شماره</label>
                        <appDialCodeSelect
                          placeholder="پیش شماره"
                          id="country"
                          v-model="dialCode"
                        />
                      </div>
                    </div>
                    <div v-if="dialCode == '98'" class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="province">استان</label>
                        <appProvinceSelect
                          placeholder="استان محل زندگی"
                          id="province"
                          v-model="user.province_id"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-xl-6 mb-3">
                      <div class="form-group text-right">
                        <label for="roles">سطح دسترسی</label>
                        <appRolesSelect
                          placeholder="سطح دسترسی"
                          id="roles"
                          v-model="user.roles"
                          :multiple="true"
                        />
                      </div>
                    </div>
                    <div v-if="false" class="col-12 col-xl-6 mb-3">
                      <div class="form-group text-right">
                        <label for="plans">اشتراک</label>
                        <appPlanSelector
                          placeholder="اشتراک"
                          id="plans"
                          v-model="user.plan_id"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-6 mb-3">
                      <div class="form-group text-right">
                        <label for="avatar">آواتار</label>
                        <appAvatarSelect
                          placeholder="آواتار"
                          id="avatar"
                          v-model="user.avatar_id"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="score">امتیاز</label>
                        <input
                          id="score"
                          type="number"
                          class="form-control"
                          placeholder="امتیاز"
                          v-model.number="user.score"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="referral_code">کدمعرف</label>
                        <input
                          id="referral_code"
                          type="text"
                          disabled
                          class="form-control"
                          placeholder="کدمعرفت"
                          v-model.number="user.referral_code"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-3">
                      <div class="form-group text-right">
                        <label for="order">ترتیب</label>
                        <input
                          id="order"
                          type="number"
                          class="form-control"
                          placeholder="ترتیب"
                          v-model.number="user.order"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xl-4 mb-3">
                      <div class="form-group text-right">
                        <label for="enable">فعال</label>
                        <fv-switch
                          id="enable"
                          class="form-control d-block"
                          placeholder="فعال"
                          v-model="user.enabled"
                        />
                      </div>
                    </div>
                    <div class="col-12 d-flex">
                      <div class="row">
                        <div class="col-12 text-right mb-3">
                          اضافه کردن اشتراک ویژه برای کاربر بر اساس روز
                        </div>
                        <div
                          class="col-12 mb-3 d-flex align-items-center"
                        >
                          <div class="form-group text-right mb-0">
                            <input
                              id="premiumDays"
                              type="number"
                              class="form-control"
                              placeholder="تعداد روز"
                              v-model.number="addSubscribeDay"
                            />
                          </div>
                          <button
                            v-if="id !== 'new'"
                            @click="addSubscribe"
                            type="button"
                            :disabled="!addSubscribeDay"
                            class="btn btn-success mr-3"
                          >
                            اضافه کردن اشتراک
                            <i class="fas fa-plus" />
                          </button>
                        </div>
                      </div>
                    </div>
                     <div class="w-100">
                        <div class="col-12 text-right mb-3">
                          اضافه یا حذف کتاب برای کاربر
                        </div>
                        <div
                          class="col-12  mb-3 d-flex align-items-center"
                        >
                          <div class="form-group text-right mb-0">
                            <input
                              type="number"
                              class="form-control inpot"
                              placeholder="شناسه کتاب "
                              @change="setId"
                            />
                          </div>
                          <button
                            v-if="id !== 'new'"
                            @click="addbook"
                            type="button"
                            class="btn btn-success mr-3 addbtn"
                          >
                          <!-- :disabled="!addSubscribeDay" -->
                          اضافه کردن کتاب 
                            <!-- <i class="fas fa-plus" /> -->
                          </button>
                          <button
                            v-if="id !== 'new'"
                            @click="deleteBook"
                            type="button"
                            class="btn btn-danger mr-3 delbtn"
                          >
                            <!-- :disabled="!addSubscribeDay" -->
                            حذف کردن کتاب  
                            <!-- <i class="fas fa-trash" /> -->
                          </button>
                        </div>
                      </div>
                     
                  </div>
                  <div class="clearfix" />
                </div>
              </card>
            </div>

            <div class="col-12 col-md-6 col-lg-5 col-xl-4 mb-4">
              <user-card class="h-100" :data="user" />
            </div>

            <div class="col-12 mb-4">
              <card class="card h-100" title="مدیا">
                <div>
                  <div class="form-row">
                    <div class="col-12 mb-3">
                      <div class="form-group text-right">
                        <label for="profile_picture">عکس پروفایل</label>
                        <appFileUploader
                          id="profile_picture"
                          v-model="user.profile_picture"
                          :multiple="false"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="clearfix" />
                </div>
              </card>
            </div>

            <div v-if="id !== 'new'" class="col-12 mb-4">
              <card
                class="card h-100"
                :title="`${
                  user.name
                    ? `سفارش های ${user.name || ''} ${user.family_name || ''} `
                    : 'سفارش ها'
                }`"
              >
                <div class="row">
                  <div class="col-12 mb-3">
                    <fvTable
                      class="fv-size-lg"
                      v-if="orders.items && orders.items.length"
                      :fields="fields"
                      :rows="orders.items"
                    >
                      <template slot="field-#" slot-scope="scope">
                        <span>{{
                          scope.index +
                          1 +
                          (ordersPage - 1) *
                            (orders.pagination.page === 1
                              ? 0
                              : orders.pagination.per_page)
                        }}</span>
                      </template>

                      <template slot="field-شماره سفارش" slot-scope="scope">
                        {{ scope.row.order_id || "---" }}
                      </template>
                      <template slot="title-مبلغ نهایی پرداخت شده"
                        >مبلغ نهایی پرداخت شده</template
                      >
                      <template
                        slot="field-مبلغ نهایی پرداخت شده"
                        slot-scope="scope"
                      >
                        <div>
                          {{
                            `${
                              scope.row.final_price
                                ? `${$priceMask(scope.row.final_price)}`
                                : "---"
                            } `
                          }}
                        </div>
                      </template>

                      <template slot="title-مبلغ بدون تخفیف"
                        >مبلغ بدون تخفیف</template
                      >
                      <template slot="field-مبلغ بدون تخفیف" slot-scope="scope">
                        <div>
                          {{
                            `${
                              scope.row.price
                                ? `${$priceMask(scope.row.price)}`
                                : "---"
                            } `
                          }}
                        </div>
                      </template>

                      <template slot="title-مبلغ تخفیف">مبلغ تخفیف</template>
                      <template slot="field-مبلغ تخفیف" slot-scope="scope">
                        <div>
                          {{
                            `${
                              scope.row.discount_price
                                ? `${$priceMask(scope.row.discount_price)}`
                                : "---"
                            } `
                          }}
                        </div>
                      </template>
                      <template slot="title-واحد پول">واحد پول</template>
                      <template slot="field-واحد پول" slot-scope="scope">
                        <div>{{ scope.row.currency || "ریال" }}</div>
                      </template>

                      <template slot="field-تاریخ ثبت" slot-scope="scope">
                        {{ $dateTimeFormat(scope.row.created_at) }}
                      </template>
                      <template
                        slot="field-تاریخ بروزرسانی وضعیت"
                        slot-scope="scope"
                      >
                        {{ $dateTimeFormat(scope.row.updated_at) }}
                      </template>


                      <template slot="field-وضعیت" slot-scope="scope">
                        <div v-if="scope.row.is_paid" class="text-success">
                          پرداخت شده
                          <i class="far fa-check-circle" />
                        </div>
                        <div
                          v-else-if="scope.row.is_paid === false"
                          class="text-danger"
                        >
                          پرداخت نشده
                          <i class="far fa-times-circle" />
                        </div>
                        <div v-else class="text-warning">
                          نامعلوم
                          <i class="far fa-clock" />
                        </div>
                      </template>
                      <template slot="field-actions" slot-scope="scope">
                        <router-link
                          :to="{
                            name: 'edit_order',
                            params: { id: scope.row.order_id },
                          }"
                          class="btn btn-warning btn-sm"
                        >
                          مشاهده
                          <i class="far fa-edit" />
                        </router-link>
                      </template>
                    </fvTable>
                  </div>
                  <div
                    class="col-12 text-center mt-5"
                    v-if="
                      Object.keys(orders.pagination).length &&
                      orders.pagination.pages > 1
                    "
                  >
                    <appPagination
                      :pageCount="orders.pagination.pages"
                      v-model="ordersPage"
                      @input="changePage"
                    />
                  </div>
                </div>

                <div class="clearfix" />
              </card>
            </div>
            <!-- books -->
            <div class="col-12 mb-4">
              <card
                class="card h-100"
                :title="`${
                  user.name
                    ? `کتاب های ${user.name || ''} ${user.family_name || ''} `
                    : 'سفارش ها'
                }`"
              >
                <table class="table table-striped rtl" v-if="books.length>0">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">نام کتاب</th>
                      <th scope="col">شناسه کتاب</th>
                      <th scope="col">تاریخ خرید</th>
                      <th scope="col"> مبلغ ارزی(یورویی)</th>
                      <th scope="col">مبلغ ریالی</th>
                      <th scope="col">مبلغ نهایی پرداخت شده</th>
                      
                      <!-- {{ $dateTimeFormat(scope.row.created_at) }} -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(book,index) in books" :key="book.id">
                      <th scope="row">{{ index+1 }}</th>
                      <td>{{ book.title }}</td>
                      <td>{{ book.id }}</td>
                      <td>{{$dateTimeFormat(book.createTime)}}</td>
                      <td>{{book.euroPrice}}</td>
                      <td>{{ book.tprice }}</td>
                      <td>{{ book.price }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else>
                  <p class="text-center">این کاربر هیچ کتابی خریداری نکرده است.</p>
                </div>
                <div class="clearfix" />
              </card>
            </div>
            <!-- End books -->
            <div v-if="id !== 'new'" class="col-12 mb-4">
              <card
                class="card h-100"
                :title="`${
                  user.name
                    ? `معرف شده ها توسط ${user.name || ''} ${
                        user.family_name || ''
                      } `
                    : 'سفارش ها'
                }`"
              >
                <div class="row">
                  <div class="col-12 mb-3">
                    <fvTable
                      class="fv-size-lg"
                      v-if="referrals.items && referrals.items.length"
                      :fields="referralFields"
                      :rows="referrals.items"
                    >
                      <template slot="field-#" slot-scope="scope">
                        <span>{{
                          scope.index +
                          1 +
                          (referralPage - 1) *
                            (referrals.pagination.page === 1
                              ? 0
                              : referrals.pagination.per_page)
                        }}</span>
                      </template>
                      <template slot="field-نام" slot-scope="scope">
                        {{ scope.row.name || "---" }}
                      </template>
                      <template slot="field-نام خانوادگی" slot-scope="scope">
                        {{ scope.row.family_name || "---" }}
                      </template>
                      <template slot="field-شماره موبایل" slot-scope="scope">
                        <div dir="ltr">{{ scope.row.mobile || "---" }}</div>
                      </template>
                      <template slot="field-نام کاربری" slot-scope="scope">
                        <div dir="ltr">{{ scope.row.username || "---" }}</div>
                      </template>
                      <template slot="field-ایمیل" slot-scope="scope">
                        <div dir="ltr">{{ scope.row.email || "---" }}</div>
                      </template>
                      <!-- <template slot="field-followings" slot-scope="scope">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b class="ml-2">{{
                            scope.row.total_followings_count || 0
                          }}</b>
                          نفر
                        </div>
                      </template>
                      <template slot="field-followers" slot-scope="scope">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b class="ml-2">{{
                            scope.row.total_followers_count || 0
                          }}</b>
                          نفر
                        </div>
                      </template> -->
                      <template slot="field-عکس" slot-scope="scope">
                        <div class="user_image_paginate">
                          <img
                            class="icon"
                            v-if="
                              scope.row.profile_picture &&
                              scope.row.profile_picture.path
                            "
                            :src="`${media_url}/${scope.row.profile_picture.path}?max=30`"
                          />

                          <div v-else>
                            <i class="far fa-user-circle defaultIcon" />
                          </div>
                        </div>
                      </template>
                      <template slot="field-تاریخ ثبت نام" slot-scope="scope">
                        {{ $dateTimeFormat(scope.row.created_at) }}
                      </template>
                      <template slot="field-actions" slot-scope="scope">
                        <button
                          @click="
                            $router.push({
                              name: 'edit_user',
                              params: { id: scope.row.id },
                            })
                          "
                          class="btn btn-warning btn-sm"
                        >
                          تغییر
                          <i class="far fa-edit" />
                        </button>
                      </template>
                    </fvTable>
                  </div>
                  <div
                    class="col-12 text-center mt-5"
                    v-if="
                      Object.keys(referrals.pagination).length &&
                      referrals.pagination.pages > 1
                    "
                  >
                    <appPagination
                      :pageCount="referrals.pagination.pages"
                      v-model="referralPage"
                      @input="getUserReferral"
                    />
                  </div>
                </div>

                <div class="clearfix" />
              </card>
            </div>
          </div>
        </div>
      </div>
    </form>
    <fvDialog
      v-model="smsDialog"
      class="col-12 col-md-8 col-lg-6 col-xl-4 py-3"
    >
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-12 col-xl-8 mb-3">
          <div class="form-group text-right">
            <label for="content" class="mb-1">متن پیامک</label>
            <textarea
              id="content"
              rows="3"
              type="text"
              class="form-control"
              placeholder="متن پیامک"
              v-model="smsContent"
            ></textarea>
          </div>
        </div>
        <div class="col-12 col-xl-4 mb-3 text-left" v-if="!smsConfirm">
          <button
            @click="smsConfirm = true"
            type="button"
            class="btn btn-success mr-2"
          >
            ارسال
          </button>
        </div>
        <div class="col-12 col-xl-4 mb-3" v-if="smsConfirm">
          <div>آیا مطمئن هستید؟</div>
          <button @click="sendSms" type="button" class="btn btn-success mr-2">
            بلی
          </button>
          <button
            @click="smsConfirm = false"
            type="button"
            class="btn btn-danger mr-2"
          >
            لغو
          </button>
        </div>
      </div>
    </fvDialog>
  </div>
</template>
<script>
import { StatsCard } from "@/components/index";
import { API_MEDIA_URL, API_URL2 } from "@/env";
import axios from "axios";
import Modela from "modela";
import Vue from "vue";
import { mapActions } from "vuex";
import appAvatarSelect from "../../components/appAvatarSelect";
import appDialCodeSelect from "../../components/appDialCodeSelect";
import appFileUploader from "../../components/appFileUploader";
import appPagination from "../../components/appPagination";
import appPlanSelector from "../../components/appPlanSelector";
import appProvinceSelect from "../../components/appProvinceSelect";
import appRolesSelect from "../../components/appRolesSelect";
import userModel from "../../models/users";
import MembersCard from "../UserProfile/MembersCard.vue";
import UserCard from "../UserProfile/UserCard.vue";

export default {
  name: "user_profile",
  components: {
    UserCard,
    appPagination,
    MembersCard,
    appFileUploader,
    appProvinceSelect,
    StatsCard,
    appRolesSelect,
    appDialCodeSelect,
    appAvatarSelect,
    appPlanSelector,
  },
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      ...mapActions("main", ["crud"]),
      id,
      media_url: API_MEDIA_URL,
      baseUrl: API_URL2,
      smsDialog: false,
      dialCode: "98",
      isRefresh:false,
      user: {
      },
      books: [],
      orders: {
        items: [],
        pagination: {},
      },
      token:Vue.$cookies.get("accessToken"),
      referrals: {
        items: [],
        pagination: {},
      },
      ordersPage: 1,
      bookId:'',
      referralPage: 1,
      fields: [
        "#",
        "شماره سفارش",
        "مبلغ بدون تخفیف",
        "مبلغ تخفیف",
        "مبلغ نهایی پرداخت شده",
        "واحد پول",
        "تاریخ ثبت",
        "تاریخ بروزرسانی وضعیت",
        "وضعیت",
        "actions",
      ],
      referralFields: [
        "#",
        "نام",
        "نام خانوادگی",
        "نام کاربری",
        "شماره موبایل",
        "تاریخ ثبت نام",
        "عکس",
        "actions",
      ],
      addSubscribeDay: null,
      smsContent: null,
      smsConfirm: false,
    };
  },
  methods: {
    async changePage() {
      this.getUserOrders();
    },
    async sendSms() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const filters = { id: this.id };
        const data = {
          filters,
          content: this.smsContent,
          limit: 1,
          page: 1,
        };
        const sms = await this.crud({
          action: "post",
          section: "sms",
          data,
          showError: true,
        });
        this.$successAlert();
      } catch (e) {
        // console.log(e)
      } finally {
        this.smsDialog = false;
        this.smsConfirm = false;
        this.smsContent = null;
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },

    async getBooks() {
      try {
        const token = Vue.$cookies.get("accessToken");
        const books = await axios.get(`${this.baseUrl}/panel/book/${this.id}`, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        this.books = books.data;
      } catch (err) {
        console.log(err);
      }
    },
    setId(e){
      this.bookId=e.target.value;
    },

    async addbook(){
        if(this.bookId===""){
        return this.$swal.fire({
            position: "center",
            icon: "error",
            title:
              "لطفا شناسه کتاب را وارد کنید.",
            showConfirmButton: false,
            timer: 3000,
      })
      }
     try {
        const token = Vue.$cookies.get("accessToken")
        const result = await axios.get(`${this.baseUrl}/panel/premium/book/${this.id}/${this.bookId}`,{
        headers:{
            Authorization: "Bearer " + this.token,
            Accept: "application/json",
            "Content-Type": "application/json",
        }
      })
      const status = result.data.state;
      switch (status) {
        case 'success':
        this.isRefresh=true;
             this.$swal.fire({
                position: "center",
                icon: "success",
                title:
                  "کتاب مورد نظر به کتابخانه کاربر اضافه شد.",
                showConfirmButton: false,
                timer: 3000,
      })
          break;
        case "exist":
          this.$swal.fire({
                position: "center",
                icon: "error",
                title:
                  "کتابی که انتخاب کرده‌اید در کتابخانه کاربر وجود دارد.",
                showConfirmButton: false,
                timer: 3000,
      })
         break;
        case "notValid":
         this.$swal.fire({
                position: "center",
                icon: "error",
                title:
                  "شناسه وارد شده صحیح نمیباشد.",
                showConfirmButton: false,
                timer: 3000,
      })
        break;
      }
     } catch (err) {
       console.log(err)
     }finally{
       if(this.isRefresh){
        return setTimeout(() => {
          document. location. reload()
        }, 500);
       }
     }
    },
    async deleteBook(){
      if(this.bookId===""){
        return this.$swal.fire({
            position: "center",
            icon: "error",
            title:
              "لطفا شناسه کتاب را وارد کنید.",
            showConfirmButton: false,
            timer: 3000,
      })
      }
     try {
        const token = Vue.$cookies.get("accessToken")
        const book = await axios.delete(`${this.baseUrl}/panel/premium/book/${this.id}/${this.bookId}`,{
        headers:{
            Authorization: "Bearer " + this.token,
            Accept: "application/json",
            "Content-Type": "application/json",
        }
      })
      const status = book.data.state;
      switch (status) {
        case 'success':
        this.isRefresh=true;
            this.$swal.fire({
                position: "center",
                icon: "success",
                title:
                  "کتاب مورد نظر از کتابخانه کاربر حذف شد.",
                showConfirmButton: false,
                timer: 3000,
      })
          break;
        case "notExist":
             this.$swal.fire({
                position: "center",
                icon: "error",
                title:
                  "این کتاب در سیستم وجود ندارد.",
                showConfirmButton: false,
                timer: 3000,
      })
          break;
        case "notValid":
          this.$swal.fire({
            position: "center",
            icon: "error",
            title:
              "شناسه وارد شده صحیح نمیباشد.",
            showConfirmButton: false,
            timer: 3000,
      })
          break;
       
      }
     } catch (err) {
       console.log(err)
     }finally{
       if(this.isRefresh){
         return setTimeout(() => {
        document. location. reload()
       }, 500);
       }
     }
    },

    async getData() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const user = await this.crud({
          action: "get",
          section: "accounts",
          id: this.id,
          showError: true,
        });
        if (user.data) {
          const result = user.data;
          if (!('enabled' in result)) {
            result.enabled = false;
          }
          let item = new Modela(userModel);
          item = item.$clean();
          item = item.$set(result);
          this.user = item.$clean().$export();

          if (item.mobile) {
            const mobileArr = item.mobile.match(/[^()]+/g);
            if (mobileArr.length === 2) {
              this.dialCode = mobileArr[0];
              this.user.mobile = mobileArr[1];
            }
          }
          await Promise.all([this.getUserReferral(), this.getUserOrders()]);
        }
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async post() {
      try {
        if (this.user.mobile)
          this.user.mobile = `(${this.dialCode})${this.user.mobile}`;
        this.$store.commit("main/SET", { key: "loading", value: true });
        const newUser = await this.crud({
          action: "post",
          section: "accounts",
          data: this.user,
          showError: true,
        });
        // this.$successAlert()
        this.$router.go(-1);
        // await this.$router.push({name: 'users'})
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async put() {
      try {
        if (this.user.mobile)
          this.user.mobile = `(${this.dialCode})${this.user.mobile}`;

        this.$store.commit("main/SET", { key: "loading", value: true });
        const updateUSer = await this.crud({
          action: "put",
          section: "accounts",
          id: this.id,
          data: this.user,
          showError: true,
        });
        this.$successAlert();
        this.$router.go(-1);
        // await this.$router.push({name: 'users'})
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async del() {
      if (!(await this.$confirmAlert())) return false;
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const deleted = await this.crud({
          action: "delete",
          section: "accounts",
          id: this.id,
          showError: true,
        });
        await this.$successAlert();
        // await this.$router.push({name: 'users'})
        await this.$router.go(-1);
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async submit() {
      if (this.id !== "new") this.put();
      else this.post();
    },
    async getUserOrders() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const filters = { account_id: this.id };
        const orders = await this.crud({
          action: "get",
          section: "orders",
          query: `filters=${JSON.stringify(filters)}&page=${
            this.ordersPage
          }&sort=-updated_at`,
          perPage: 10,
        });
        const result = orders.data;
        this.$set(this.orders, "pagination", result.pagination);
        this.$set(this.orders, "items", result.items);
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },

    async addSubscribe() {
      if (!this.addSubscribeDay || !this.id) return;
      const text = `آیا به افزودن ${this.addSubscribeDay} روز به اشتراک ویژه این کاربر مطمئن هستید؟`;
      if (!(await this.$confirmAlert(text, "بله"))) return false;
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const addSubscribe = await this.crud({
          action: "post",
          section: "premium",
          data: {
            account_id: this.id,
            days: this.addSubscribeDay,
          },
          showError: true,
        });
        await this.$successAlert();
        await this.getData();
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },

    async getUserReferral() {
      this.$store.commit("main/SET", { key: "loading", value: true });

      try {
        const referrals = await this.crud({
          action: "get",
          section: `accounts/${this.id}/referrals`,
          query: `page=${this.referralPage}&sort=-updated_at`,
          perPage: 1,
        });

        const result = referrals.data;
        this.$set(this.referrals, "pagination", result.pagination);
        this.$set(this.referrals, "items", result.items);
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
  },
  async created() {
    this.getBooks();
    if (this.id !== "new") await this.getData();
    else {
      let item = new Modela(userModel);
      this.item = item.$clean().$export();
    }
  },
};
</script>
<style>

td {
  text-align: center;
  direction: rtl;
  /* width:100px !important; */
}

th {
  text-align: center !important;
  direction: rtl;
}

.addbtn{
  width:200px !important;
}

.delbtn{
  width:200px !important;
}

.inpot{
  width:120px !important;
}

</style>
